export enum CurrencyType {
  HKD = 1,
  INR = 2,
  EUR = 3,
  USD = 4,
  THB = 5,
  AED = 6,
  PHP = 7,
  GBP = 8,
  RMB = 9,
  PTS = 10,
  KRW = 11,
  IDR = 12,
  PTU = 13,
  PTE = 14,
  PTG = 15,
  PTH = 16,
  PTI = 17,
  PUI = 18,
  PTR = 19,
  PTA = 20,
  PTM = 21,
  P = 22,
  PTD = 23,
  IR = 24,
  PTAD = 25,
  PBU = 26,
  VND = 27,
  EHK = 28,
  PKR = 29,
  PKU = 30,
  PR = 31,
  PIN = 32,
  BDT = 33,
  PSU = 34,
  PNU = 35,
  PAU = 36,
  PZU = 37,
  PHK = 38,
  NPR = 39,
  PSD = 40,
  USDT = 41,
  MYR = 42,
  BRL = 43,
  INP = 44,
  ZAR = 45,
  PTP = 46,
  NHK = 47,
  LKR = 48,
  CAD = 49
  // PRS = 50,
  // NRS = 51,
  // IRR = 52
}

export type CurrencyTypeKey = keyof typeof CurrencyType
